import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import { forkJoin } from 'rxjs';
import { LookupDataServiceService } from 'src/app/services/lookup-data-service.service';
import { ReportService } from 'src/app/services/report.service';
import { UserSessionService } from 'src/app/services/usersession.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-hc-customer-report',
    templateUrl: './hc-customer-report.component.html',
    styleUrls: ['./hc-customer-report.component.scss']
})
export class HcCustomerReportComponent implements OnInit {
    enableToogleBtn = false
    HCcustomerReportForm: FormGroup;
    toMinDate: Date;
    toMaxDate = new Date()
    @ViewChild('startDate') startDateDatePicker: MatDatepicker<Date>;
    @ViewChild('endDate') endDateDatePicker: MatDatepicker<Date>;
    serviceProviderTypeList: any = []
    filteredList1: any = []
    LoginRoleId: any;
    sessionDataString: any;
    userListUnEncryptedCustReport: any[] = [];
    serviceQueue: any = []
    constructor(
        private fb: FormBuilder,
        private reportService: ReportService,
        private sessionService: UserSessionService,
        private lookupDataService: LookupDataServiceService
    ) {
        this.sessionDataString = JSON.parse(localStorage.getItem(
            this.sessionService.localStorageSessionKey));
    }


    ngOnInit(): void {
        this.init()
        this.loadServiceQueue();
        this.executeServiceQueue();
        this.HCcustomerReportForm.patchValue({ UserId: this.sessionDataString.id })
    }
    init() {
        this.HCcustomerReportForm = this.fb.group({
            startDate: [null],
            endDate: [null],
            serviceProviderId: [null],
            toggleSwitchOn: [false, Validators.required],
            UserId: []
        });
    }
    Reset() {
        this.HCcustomerReportForm.reset()
    }
    openStartDateDatePicker() {
        this.startDateDatePicker.open();
    }

    openEndDateDatePicker() {
        this.endDateDatePicker.open();
        this.toMinDate = this.HCcustomerReportForm.controls["startDate"].value;
        // this.toMaxDate = this.addMonths(this.toMinDate, 3);
    }
    loadServiceQueue() {
        this.serviceQueue.push(this.lookupDataService.getServiceProvider());
        this.serviceQueue.push(this.reportService.gettingEmailForHcReport());
    }
    executeServiceQueue() {
        forkJoin(this.serviceQueue).subscribe((serviceResponse) => {
            this.serviceProviderTypeList = serviceResponse[0];
            this.userListUnEncryptedCustReport = serviceResponse[1]
            this.serviceProviderTypeList = this.serviceProviderTypeList.sort((a, b) => a.value.localeCompare(b.value));
            this.filteredList1 = this.serviceProviderTypeList.slice()
            if (this.userListUnEncryptedCustReport && this.userListUnEncryptedCustReport.includes(this.sessionDataString.emailid))
                this.enableToogleBtn = true

        });
    }

    generateExcel() {
        if (this.HCcustomerReportForm.value.startDate || this.HCcustomerReportForm.value.endDate) {
            if (!this.HCcustomerReportForm.value.startDate && this.HCcustomerReportForm.value.endDate) {
                Swal.fire({
                    icon: 'warning',
                    title: 'From date should not be empty',
                    position: 'center',

                })
            }
            else if (!this.HCcustomerReportForm.value.endDate && this.HCcustomerReportForm.value.startDate) {
                Swal.fire({
                    icon: 'warning',
                    title: 'End date should not be empty',
                    position: 'center',

                })
            }
            else if (this.HCcustomerReportForm.value.startDate > this.HCcustomerReportForm.value.endDate) {
                if (this.HCcustomerReportForm.value.endDate) {

                    Swal.fire({
                        icon: 'warning',
                        title: 'End Date should be greater than Start Date',
                        position: 'center',

                    })
                }
            }
            else {
                const val = Object.keys(this.HCcustomerReportForm.value)
                    .filter(key => this.HCcustomerReportForm.value[key] !== null && this.HCcustomerReportForm.value[key] !== undefined)
                    .reduce((acc, key) => {
                        acc[key] = this.HCcustomerReportForm.value[key];
                        return acc;
                    }, {} as any);

                this.reportService.getCustomerReport(val).subscribe((data) => {
                    if (data) {
                        const linkSource = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64, ' + data;
                        const downloadLink = document.createElement('a');
                        const fileName = 'Home-Connect Customer Report.xls';
                        downloadLink.href = linkSource;
                        downloadLink.download = fileName;
                        downloadLink.click();
                    }
                });
            }
        }
        else {
            const val = Object.keys(this.HCcustomerReportForm.value)
                .filter(key => this.HCcustomerReportForm.value[key] !== null && this.HCcustomerReportForm.value[key] !== undefined)
                .reduce((acc, key) => {
                    acc[key] = this.HCcustomerReportForm.value[key];
                    return acc;
                }, {} as any);

            this.reportService.getCustomerReport(val).subscribe((data) => {
                if (data) {
                    const linkSource = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64, ' + data;
                    const downloadLink = document.createElement('a');
                    const fileName = 'Home-Connect Customer Report.xls';
                    downloadLink.href = linkSource;
                    downloadLink.download = fileName;
                    downloadLink.click();
                }
            });

        }
    }

    //LIVE branch
    generateUnEncryptedExcel() {
        if (this.HCcustomerReportForm.value.startDate || this.HCcustomerReportForm.value.endDate) {
            if (!this.HCcustomerReportForm.value.startDate && this.HCcustomerReportForm.value.endDate) {
                Swal.fire({
                    icon: 'warning',
                    title: 'From date should not be empty',
                    position: 'center',

                })
            }
            else if (!this.HCcustomerReportForm.value.endDate && this.HCcustomerReportForm.value.startDate) {
                Swal.fire({
                    icon: 'warning',
                    title: 'End date should not be empty',
                    position: 'center',

                })
            }
            else if (this.HCcustomerReportForm.value.startDate > this.HCcustomerReportForm.value.endDate) {
                if (this.HCcustomerReportForm.value.endDate) {

                    Swal.fire({
                        icon: 'warning',
                        title: 'End Date should be greater than Start Date',
                        position: 'center',

                    })
                }
            }
            else {
                this.reportService.getUnencryptedCustomerReport(this.HCcustomerReportForm.value).subscribe((data) => {

                    if (data) {
                        const linkSource = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64, ' + data;
                        const downloadLink = document.createElement('a');
                        const fileName = 'Home-Connect Customer Report.xls';
                        downloadLink.href = linkSource;
                        downloadLink.download = fileName;
                        downloadLink.click();

                    }
                });

            }
        }
        else {


            this.reportService.getUnencryptedCustomerReport(this.HCcustomerReportForm.value).subscribe((data) => {

                if (data) {
                    const linkSource = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64, ' + data;
                    const downloadLink = document.createElement('a');
                    const fileName = 'Home-Connect Customer Report.xls';
                    downloadLink.href = linkSource;
                    downloadLink.download = fileName;
                    downloadLink.click();

                }
            });

        }
    }
}
